import { AddressApi } from '@/api';
import { IAddress, IAddressForm } from '@/models';
import { googlePlaceService } from '@/services';

const getPointFromPlace = (
  place: google.maps.places.PlaceResult,
): IAddressForm['point'] | undefined => {
  const lat = place.geometry?.location?.lat?.();
  const lng = place.geometry?.location?.lng?.();

  if (lat === undefined || lng === undefined) {
    return undefined;
  }

  return {
    type: 'Point',
    coordinates: [lng, lat],
  };
};

export const buildAddressPayloadFromPlace = async (
  place: google.maps.places.PlaceResult,
): Promise<IAddressForm | null> => {
  let addressDetails: IAddressForm | null = null;

  if (place.place_id) {
    try {
      addressDetails = await googlePlaceService.getPlaceDetails(place.place_id);
    } catch {
      addressDetails = null;
    }
  }

  if (!addressDetails && place.address_components?.length) {
    addressDetails = googlePlaceService.getAddressDetails(place);
  }

  if (!addressDetails) {
    return null;
  }

  const point = getPointFromPlace(place);

  if (point) {
    return {
      ...addressDetails,
      point,
    };
  }

  return addressDetails;
};

export const syncPlaceAddressToMasterIndex = async (
  place: google.maps.places.PlaceResult,
): Promise<IAddress> => {
  const addressPayload = await buildAddressPayloadFromPlace(place);

  if (!addressPayload) {
    throw new Error('Failed to resolve address details for this marker.');
  }

  // The Google-derived business name is a per-CFS attribute; keep it off the
  // shared master address record.
  const { businessName, ...payload } = addressPayload;
  const response = await AddressApi.createAddress(payload as IAddressForm);
  return response.data;
};
